module.exports = __webpack_public_path__ + "img/cropped-image-2022-02-06T094724.734.5088a571.png";